import { render, staticRenderFns } from "./AttachmentsModal.vue?vue&type=template&id=01fddf7a&"
import script from "./AttachmentsModal.vue?vue&type=script&lang=js&"
export * from "./AttachmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports